import React, { FC, ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons'
import clsx from 'clsx'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'

const ClosedInfoBlockComponent: FC<{
  handleToggle: () => void
  tableOpen: boolean
  children: ReactNode
}> = ({ handleToggle, tableOpen, children }) => {
  const { t } = useTranslation()

  return (
    <Stack
      className={clsx('header', { open: tableOpen })}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onClick={handleToggle}
    >
      {children}
      <Box display="flex" alignItems="center">
        <Typography fontWeight="bold" sx={{ mr: 2 }}>
          {tableOpen ? t('minimize') : t('show')}
        </Typography>
        {tableOpen ? <ArrowDropUp /> : <ArrowDropDown />}
      </Box>
    </Stack>
  )
}

export const ClosedInfoBlock = React.memo(ClosedInfoBlockComponent, isEqual)
